import { render, staticRenderFns } from "./SurveyManagementEditRatingQuestion.vue?vue&type=template&id=d70af98a&"
import script from "./SurveyManagementEditRatingQuestion.vue?vue&type=script&lang=js&"
export * from "./SurveyManagementEditRatingQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SurveyManagementEditRatingQuestion.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d70af98a')) {
      api.createRecord('d70af98a', component.options)
    } else {
      api.reload('d70af98a', component.options)
    }
    module.hot.accept("./SurveyManagementEditRatingQuestion.vue?vue&type=template&id=d70af98a&", function () {
      api.rerender('d70af98a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-management/edit-question/questions/SurveyManagementEditRatingQuestion.vue"
export default component.exports